export { default } from './ArchiveSearchResults';
